import axios from 'axios';

const KEY = 'lumera_pending_action';
const MAX_AGE_MS = 30 * 60 * 1000;
const API = process.env.REACT_APP_BACKEND_URL;
const cfg = { withCredentials: true };

/** Remember what a guest tried to do (like/follow/comment) so it runs after sign-in. */
export const savePendingAction = (action) => {
  if (!action) return;
  localStorage.setItem(KEY, JSON.stringify({
    ...action,
    returnTo: window.location.pathname + window.location.search,
    ts: Date.now(),
  }));
};

export const peekPendingAction = () => {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!a || Date.now() - a.ts > MAX_AGE_MS) { localStorage.removeItem(KEY); return null; }
    return a;
  } catch { localStorage.removeItem(KEY); return null; }
};

export const clearPendingAction = () => localStorage.removeItem(KEY);

/** Where to land after sign-in: back to the guest's spot if they had a pending action. */
export const postLoginPath = () => peekPendingAction()?.returnTo || '/dashboard';

const RUNNERS = {
  like_post: (a) => axios.post(`${API}/api/community/posts/${a.target}/like`, {}, cfg),
  comment_post: (a) => axios.post(`${API}/api/community/posts/${a.target}/comments`, { text: a.text }, cfg),
  follow_user: (a) => axios.post(`${API}/api/community/follow/${a.target}`, {}, cfg),
  like_activity: (a) => axios.post(`${API}/api/community/activity/${a.target}/like`, {}, cfg),
  comment_activity: (a) => axios.post(`${API}/api/community/activity/${a.target}/comment`, { text: a.text }, cfg),
};

export const runPendingAction = async (action) => {
  const run = RUNNERS[action?.type];
  if (!run) return false;
  try { await run(action); return true; } catch (e) {
    // Already liked/following is still a success from the user's point of view.
    return [400, 409].includes(e?.response?.status) && action.type !== 'comment_post' && action.type !== 'comment_activity';
  }
};
